import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { GuardianInsertRequest } from "../demographics-guardian-table/student-add-guardian/GuardianInsertRequest";
import { GuardianUpdateRequest } from "../demographics-guardian-table/student-edit-guardian/GuardianUpdateRequest";

@Injectable()
export class DataService_Student_Demographics {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	StudentGetFullInfo(PersonID) {
		var postResult$ = new Subject();
		var url = "StudentDemographic/StudentGetFullInfo?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadGuardian(PersonID) {
		var postResult$ = new Subject();
		var url = "StudentDemographic/GuardianFullInfoGetList?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RelationshipInfoGetList(SchoolID) {
		var postResult$ = new Subject();
		var url = "StudentDemographic/RelationshipInfoGetList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LanguageInfoGetList() {
		var postResult$ = new Subject();
		var url = "StudentDemographic/LanguageInfoGetList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GuardianInsert(parms: GuardianInsertRequest) {
		var postResult$ = new Subject();
		var url = "StudentDemographic/GuardianInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GuardianUpdate(parms: GuardianUpdateRequest) {
		var postResult$ = new Subject();
		var url = "StudentDemographic/GuardianUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DeleteGuardian(ParentID) {
		var postResult$ = new Subject();
		var url = "StudentDemographic/DeleteGuardian?ParentID=" + ParentID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	CurrentReminderInfoSelectList(PersonID) {
		var postResult$ = new Subject();
		var url = "StudentDemographic/CurrentReminderInfoSelectList?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	CurrentReminderModeInfoSelect(PersonID) {
		var postResult$ = new Subject();
		var url = "StudentDemographic/CurrentReminderModeInfoSelect?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
